import {
    startAuthentication,
    startRegistration,
    browserSupportsWebAuthn,
} from '@simplewebauthn/browser';

import * as Sentry from "@sentry/browser";
import Sortable from 'sortablejs';
import { LGraph, LGraphCanvas, LiteGraph } from 'litegraph.js';
import 'litegraph.js/css/litegraph.css';
import * as FilePond from 'filepond';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
import 'filepond/dist/filepond.min.css';
import Hls from 'hls.js';

// Make Sortable globally available
window.Sortable = Sortable;

// LiteGraph.js (für Automation-Editor im dhsn/tickets-Package)
window.LGraph = LGraph;
window.LGraphCanvas = LGraphCanvas;
window.LiteGraph = LiteGraph;

// FilePond (chunked/resumable Uploads, genutzt vom dhsn/video-platform-Package)
FilePond.registerPlugin(FilePondPluginFileValidateType, FilePondPluginFileValidateSize);
window.FilePond = FilePond;

// hls.js (adaptive HLS-Wiedergabe im dhsn/video-platform-Player)
window.Hls = Hls;

// WebAuthn-Helfer global verfügbar machen (genutzt vom dhsn/yubikey-management-Wizard).
window.startRegistration = startRegistration;
window.startAuthentication = startAuthentication;
window.browserSupportsWebAuthn = browserSupportsWebAuthn;

require('./bootstrap');

// Spotlight (Cmd/Ctrl+K globale Suche) — bindet seinen Keydown-Listener
// selbst, kein Init-Aufruf nötig.
require('./spotlight');

document.addEventListener('alpine:init', () => {
    Alpine.data('authForm', () => ({
        mode: 'login',
        username: '',
        browserSupported: browserSupportsWebAuthn(),
        error: null,
        submit() {
            this.error = null;
 
            if (this.mode === 'login') {
                return this.submitLogin();
            }
 
            return this.submitRegister();
        },
        submitRegister() {
            window.axios
                // Ask for the registration options
                .post('/auth/passkey/options', {
                    username: this.username,
                })
                // Prompt the user to create a passkey
                .then((response) => startRegistration(response.data))
                .then((attResp) => {
                    // Ergänze attResp um den Namen des Authenticators
                    attResp.authenticatorName = this.authenticatorName;
                    return attResp;
                })
                // Verify the data with the server
                .then((attResp) => axios.post('/auth/passkey/verify', attResp))
                .then((verificationResponse) => {
                    if (verificationResponse.data?.verified) {
                        // If we're good, reload the page and
                        // the server will redirect us to the dashboard
                        return window.location.reload(); 
                    }
 
                    this.error =
                        'Something went wrong verifying the registration.';
                })
                .catch((error) => {
                    this.error = error?.response?.data?.message || error;
                });
        },
        submitLogin() {
            window.axios
                // Ask for the authentication options
                .post('/authentication/options', {
                    username: this.username,
                })
                // Prompt the user to authenticate with their passkey
                .then((response) => startAuthentication(response.data))
                // Verify the data with the server
                .then((attResp) =>
                    axios.post('/authentication/verify', attResp),
                )
                .then((verificationResponse) => {
                    // If we're good, reload the page and
                    // the server will redirect us to the dashboard
                    if (verificationResponse.data?.verified) {
                        //return window.location.reload();
                        // redirect to /saml/release-attributes
                        return window.location.replace('/saml/release-attributes');
                    }
 
                    this.error =
                        'Something went wrong verifying the authentication.';
                })
                .catch((error) => {
                    console.log(error.name);
                    switch (error.name) {
                        case 'AbortError':
                            this.error = 'Die Anfrage wurde abgebrochen.';
                            break;
                        case 'NotAllowedError':
                            this.error = 'Die Anfrage wurde abgelehnt.';
                            break;
                        case 'NotFoundError':
                            this.error =
                                'Der Authenticator wurde nicht gefunden.';
                            break;
                        case 'NotSupportedError':
                            this.error =
                                'Die Anfrage wird nicht unterstützt.';
                            break;
                        case 'SecurityError':
                            this.error =
                                'Die Anfrage wurde aus Sicherheitsgründen abgelehnt.';
                            break;
                        default:
                            this.error = error?.response?.data?.message || error;
                    }

                    const errorMessage =
                        error?.response?.data?.message || error;
 
                    if (errorMessage === 'User not found') {
                        this.mode = 'confirmRegistration';
                        return;
                    }
 
                    
                });
        },
    }));



    Alpine.data('registerPasskeyForm', () => ({
       
        username: '',
        authenticatorName: '',
        browserSupported: browserSupportsWebAuthn(),
        error: null,
        submit() {
            this.error = null;
 
            return this.submitRegister();
        },
        submitRegister() {
            window.axios
                // Ask for the registration options
                .post('/auth/passkey/options', {
                    username: this.username,
                })
                // Prompt the user to create a passkey
                .then((response) => startRegistration(response.data))
                .then((attResp) => {
                    // Ergänze attResp um den Namen des Authenticators
                    attResp.authenticatorName = this.authenticatorName;
                    console.log(attResp);
                    return attResp;
                })
                // Verify the data with the server
                .then((attResp) => axios.post('/auth/passkey/verify', attResp))
                .then((verificationResponse) => {
                    if (verificationResponse.data?.verified) {
                        // If we're good, reload the page and
                        // the server will redirect us to the dashboard
                        return window.location.reload();
                    }
 
                    this.error =
                        'Something went wrong verifying the registration.';
                })
                .catch((error) => {
                    this.error = error?.response?.data?.message || error;
                });
        }
    }));



});


Sentry.init({
    dsn: "https://1f06bc409cf04836b6bf69a4143fccd0@sentry.dssax.de/2",
    tracePropagationTargets: [
        "services.dhsn.de",
      ],
    tracesSampleRate: 0.1,
    // This sets the sample rate to be 10%. You may want this to be 100% while
    // in development and sample at a lower rate in production
    replaysSessionSampleRate: 0,
  
    // If the entire session is not sampled, use the below sample rate to sample
    // sessions when an error occurs.
    replaysOnErrorSampleRate: 1.0,
  
    integrations: [
      Sentry.replayIntegration({
        // Additional SDK configuration goes in here, for example:
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
  });
window.Sentry = Sentry;
//const replay = Sentry.getReplay();
//replay.start();